import { useState, useEffect } from "react";
import { IMultiMarket } from "@hypexone/uicore";

export const useMarketLocalState = () => {
  const [username, setUserName] = useState<string>("");
  const [multiMarketData, setMultiMarketData] = useState<IMultiMarket[]>([]);

  const getUserNameFromSessionStorage = sessionStorage.getItem("username");

  const getMultiMarketFromLocalStorage = localStorage.getItem(
    `multiMarket_${username}`
  );

  useEffect(() => {
    setUserName(getUserNameFromSessionStorage ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setUserName(getUserNameFromSessionStorage ?? "");
  }, [getUserNameFromSessionStorage]);

  useEffect(() => {
    if (username) {
      let data = [];
      const mData = getMultiMarketFromLocalStorage ?? "";
      if (mData) data = JSON.parse(atob(mData)) ?? [];
      setMultiMarketData([...data]);
    }
  }, [username, getMultiMarketFromLocalStorage]);

  return [multiMarketData, setMultiMarketData] as const;
};
